module.exports = __webpack_public_path__ + "img/China-3-hover.9a8c037b.jpg";